module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec02_235ba107531cd3593e74763d413ad8e5.jpg";